import type { ComponentType } from "react";
import { Component } from "react";

import { AjaxMethod } from "@Components/Modules/Ajax";

import type { INavigationModal, INavigationModalActionsField } from "../common/NavigationModal";
import { NavigationModal } from "../common/NavigationModal";
import type { IEmailEntryForm } from "./EmailEntryForm";
import { EmailEntryForm } from "./EmailEntryForm";
import type { IEmailVerificationForm } from "./EmailVerificationForm";
import { EmailVerificationForm } from "./EmailVerificationForm";
import type { IPasswordEntryForm } from "./PasswordEntryForm";
import { PasswordEntryForm } from "./PasswordEntryForm";
import type { ISuccessForm } from "./SuccessForm";
import SuccessForm from "./SuccessForm";
import type { IVerificationPage } from "./VerificationPage";
import { VerificationPage } from "./VerificationPage";

import * as css from "./EmailConfirmation.module.css";

export interface IEmailConfirmationFields extends INavigationModalActionsField {
    passwordValue?: string;
    emailValue?: string;
}

export enum IEmailConfirmationTypes {
    ChangeEmailType,
    VerifyEmailType,
    EmailVerificationType,
    Undefined,
}

export interface IEmailConfirmation {
    stepPasswordCheck: IPasswordEntryForm;
    stepEmailCheck: IEmailEntryForm;
    stepConfirmMod: ISuccessForm;
    stepEmailValidate: IVerificationPage;
    stepVerification: IEmailVerificationForm;
    fields: IEmailConfirmationFields;
    navigationModal: INavigationModal;
    emailConfirmationType: IEmailConfirmationTypes;
}

const getHoC = (props: IEmailConfirmation): ComponentType<INavigationModal> => {
    switch (props.emailConfirmationType) {
        case IEmailConfirmationTypes.ChangeEmailType:
            return NavigationModal(
                [PasswordEntryForm, EmailEntryForm, SuccessForm],
                [props.stepPasswordCheck, props.stepEmailCheck, props.stepConfirmMod],
                props.fields,
            );
        case IEmailConfirmationTypes.VerifyEmailType:
            return NavigationModal([VerificationPage], [props.stepEmailValidate], props.fields);
        case IEmailConfirmationTypes.EmailVerificationType:
            return NavigationModal(
                [EmailVerificationForm, PasswordEntryForm, EmailEntryForm, SuccessForm, VerificationPage],
                [
                    { ...props.stepVerification, ajaxMethod: AjaxMethod.Post },
                    props.stepPasswordCheck,
                    props.stepEmailCheck,
                    props.stepConfirmMod,
                    props.stepEmailValidate,
                ],
                props.fields,
            );
        default:
            return () => null;
    }
};

export class EmailConfirmation extends Component<IEmailConfirmation> {
    private wrapperNavigationModal: ComponentType<INavigationModal>;

    constructor(props: IEmailConfirmation) {
        super(props);

        this.wrapperNavigationModal = getHoC(props);
    }

    public render() {
        const WrapperNavigationModal = this.wrapperNavigationModal;

        return (
            <div className={css.emailConfirmationComponent}>
                <WrapperNavigationModal {...this.props.navigationModal} allowBodyScroll={true} />
            </div>
        );
    }
}
